module.exports = "https://cdn.dashboard.gifty.nl/5461/images/emoti-3.png?fd63d2b586fd4621b60f17bcfd317282";